var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 43,
    viewBox: "0 0 52 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6061 0.131012H6.29909C3.16322 0.131012 0.621094 2.67291 0.621094 5.80851C0.621094 8.94411 3.16322 11.486 6.29909 11.486H45.6061C48.742 11.486 51.2841 8.94411 51.2841 5.80851C51.2841 2.67291 48.742 0.131012 45.6061 0.131012Z",
    fill: "#FFCE34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6068 15.418H14.4788C11.3429 15.418 8.80078 17.9599 8.80078 21.0955C8.80078 24.2311 11.3429 26.773 14.4788 26.773H45.6068C48.7427 26.773 51.2848 24.2311 51.2848 21.0955C51.2848 17.9599 48.7427 15.418 45.6068 15.418Z",
    fill: "#FFCE34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6034 30.705H25.4124C22.2765 30.705 19.7344 33.2469 19.7344 36.3825C19.7344 39.5181 22.2765 42.06 25.4124 42.06H45.6034C48.7392 42.06 51.2814 39.5181 51.2814 36.3825C51.2814 33.2469 48.7392 30.705 45.6034 30.705Z",
    fill: "#FFCE34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.2af4d944fb1fb2a387d928e8f935f660.svg";
export { ForwardRef as ReactComponent };